// import i18n from '@/plugins/i18n'

export default [
  {
    portalGroup: 'press.public',
    path: 'P0101UserArticle/index',
    name: 'TTC PRESS HOME',
    component: () => import('./PgP0101MainPage')
  }
]
